<template>
  <v-text-field
    :disabled="disabled"
    :rules="ruleList"
    outlined
    type="number"
    v-model.number="value"
  ></v-text-field>
</template>

<script>
import formElementMixin from "./formElementMixin";

export default {
  mixins: [formElementMixin],
};
</script>
